import { Col, Row } from "antd";
import { PageTitle } from "../../../../../styles/global/Pages.styled";
import { Text } from "../../../Atomics/Text";
import { useTranslation } from "react-i18next";
import useFetch from "../../../../../server/useFetch";
import { Widget } from "../../../Atomics/Widget";
import { NoData } from "../../../Atomics/NoData";
import { IconWrapper } from "@synergy/icons";

export const HomepageGreenSpaces = () => {
    const { t } = useTranslation();
    const { data: greenSpacesData, refetch: refetchGreenSpacesData, isFetching: greenSpacesDataIsFetching, remove: removeGreenSpacesData } = useFetch(
        `/nova_wallboards/getgreenspacesdata`, "greenSpacesData",
        null, null, null, 'https://36lsp94v05.execute-api.eu-west-1.amazonaws.com/v3_0_01', 300000);

    return (
        <Row gutter={[16, 16]}>
            <Col span={24} id="green spaces">
                <PageTitle>
                    <Text $fontColor="coolgray-12" $fontSize="text_md" $weight="medium" $marginRight="s03">{t("Green Spaces")}</Text>
                </PageTitle>
            </Col>
            <Col span={6}>
                <Widget
                    data={{
                        background: "transparent",
                        title: t("title.Incidents by priority"),
                        icon: 'Clipboard',
                        border: null,
                        background: 'white',
                        height: '100%',
                        activeShadow: true,
                        margin: "0 0 10px 0",
                    }}
                >
                    {greenSpacesData?.incidents ?
                        getByPriorityWidget(greenSpacesData?.incidents, t)
                        : <NoData />}
                </Widget>
            </Col>
            <Col span={5}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Irrigation Efficiency"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "semiCircleGaugeChartApex",
                                height: "111px",
                                isFetching: greenSpacesDataIsFetching,
                                data: {
                                    series: [greenSpacesData?.wateringEfficincy ?? 0],
                                    labels: 'value',
                                }
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={5}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Water Consumption Of MINA & EPAL"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: greenSpacesDataIsFetching,
                                data: {
                                    number: greenSpacesData?.totalWeekEPALAndMINA,
                                    language: 'de-DE'
                                },
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={4}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.EPAL Flow Rate"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: greenSpacesDataIsFetching,
                                data: {
                                    number: greenSpacesData?.caudaEPAL,
                                    language: 'de-DE'
                                },
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={4}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.MINA Flow Rate"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: greenSpacesDataIsFetching,
                                data: {
                                    number: greenSpacesData?.caudalMINA,
                                    language: 'de-DE'
                                },
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={12}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Irrigation Water Consumption"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "220px",
                                isFetching: greenSpacesDataIsFetching,
                                data: greenSpacesData?.wateringWeek
                                    ? getAreaChartData(greenSpacesData?.wateringWeek)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={12}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "transparent",
                        title: t("title.MINA & EPAL Consumption"),
                        icon: 'Clipboard',
                        border: null,
                        background: 'white',
                        height: '100%',
                        activeShadow: true,
                        margin: "0 0 10px 0",
                        charts: [
                            {
                                chartType: "horizontalBarChartApex",
                                height: '200px',
                                isFetching: greenSpacesDataIsFetching,
                                data: greenSpacesData?.weekEPALAndMinaHorizontalBarChart ?
                                    getHorizontalChart(greenSpacesData.weekEPALAndMinaHorizontalBarChart)
                                    : null
                            },
                        ],
                    }}
                />
            </Col>

        </Row>
    );
};

const getByPriorityWidget = (data, t) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}>


                {[{ label: 'Red', count: data["red"] ?? 0 },
                { label: 'Orange', count: data["orange"] ?? 0 },
                { label: 'Yellow', count: data["yellow"] ?? 0 }].map((status, index) => (
                    <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '30%', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <IconWrapper $bgColor={status.label} $bgsize="5px" />
                            <h1 style={{ margin: '0', marginLeft: '5px' }}>{status.count}</h1>
                        </div>
                        {/* <span>{t(status.label)}</span> */}
                    </div>
                ))}
            </div>
        </div>
    );
};

const getAreaChartData = (data) => {
    const series = data.map((item) => {
        return {
            x: item.name,
            y: item.uv,
        }
    });

    return {
        series: [
            {
                name: "",
                data: series,
            }
        ],
        categories: null,
        markerSize: 3,
        unit: "m³",
        yAxisLabel: "m³",
        columnWidth: 20,
        colors: ["#66cbc8"],
        hideToolbar: true,
        hideLegend: true,
    }
}

const getHorizontalChart = (data) => {
    const result = data.map((item) => {
        return {
            name: item.name,
            value: item.uv,
        }
    });

    return {
        series: result,
        hideYAxisBorder: true,
        categories: null,
        xAxisType: null,
        labelFormat: null,
        tooltip: null,
        markerSize: null,
        unit: "m³",
        columnWidth: 20,
        xAxisLabel: "m³",
        colors: null,
        hideCSVIcon: false,
        hideToolbar: true,
        // "tooltipName": "Consumo (GWh)"
        isTopLabel: true,
    };
};